import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'humanizedDate'
})
export class HumanizedDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    moment.locale('de');
    moment.relativeTimeThreshold('y', 365);
    var valueMoment = value ? moment(value) : moment();
    var now = moment();
    return moment.duration(-now.diff(valueMoment)).humanize(true);
  }

}
